const a = (t) => ({ ...{
  actionItemsGap: "16px"
}, ...{
  sm: {
    verticalPadding: "8px",
    horizontalPadding: "8px",
    buttonGap: "4px"
  },
  md: {
    verticalPadding: "8px",
    horizontalPadding: "12px",
    buttonGap: "8px"
  },
  lg: {
    verticalPadding: "12px",
    horizontalPadding: "16px",
    buttonGap: "12px"
  }
}[t] });
export {
  a as getSectionFooterThemeOverrides
};
//# sourceMappingURL=highrise.es285.js.map
